export default {
    USERNAME: 1,
    EMAIL: 2,
    RESET_CODE: 3,
    RESET_PASSWORD: 4,
};